var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.481,
    height: 21.424,
    viewBox: "0 0 19.481 21.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-lock",
    "data-name": "Icon feather-lock",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10009",
    "data-name": "Trac\\xE9 10009",
    d: "M6.442,16.5h13.6a1.942,1.942,0,0,1,1.942,1.942v6.8a1.942,1.942,0,0,1-1.942,1.942H6.442A1.942,1.942,0,0,1,4.5,25.241v-6.8A1.942,1.942,0,0,1,6.442,16.5Z",
    transform: "translate(0 -4.759)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10010",
    "data-name": "Trac\\xE9 10010",
    d: "M10.5,11.741V7.856a4.856,4.856,0,0,1,9.712,0v3.885",
    transform: "translate(-2.115 0)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.59fe2914fdbc444b742bca1b683d3b99.svg";
export { ForwardRef as ReactComponent };